import { Box } from '@mui/material';
import React from 'react';
import { ArrayField, Datagrid, FunctionField } from 'react-admin';
import { ClassroomLocation } from 'src/components/Employees/types';
import { NoValuePlaceholder } from 'src/constants/children/form';

type GradeKey = 'PRESCHOOL_EDUCATION' | 'GRADES_1_TO_4' | 'GRADES_5_TO_11';

const gradesValuesToString: Record<GradeKey, string> = {
    PRESCHOOL_EDUCATION: 'Дошкільна освіта',
    GRADES_1_TO_4: '1-4 класи',
    GRADES_5_TO_11: '5-11 класи'
};

const orderedGrades: GradeKey[] = ['PRESCHOOL_EDUCATION', 'GRADES_1_TO_4', 'GRADES_5_TO_11'];

const getGradesString = (grades: GradeKey[]): string => {
    const applicableGrades: string[] = [];
    orderedGrades.forEach((orderedGrade: GradeKey) => {
        const classroomGrade = grades.find((gradeEntity: GradeKey) => gradeEntity === orderedGrade);
        classroomGrade && applicableGrades.push(gradesValuesToString[classroomGrade]);
    });

    return applicableGrades.join(', ');
};

const getValueOrPlaceholder = (value?: string | number): string | number => {
    let valueOrPlaceholder: string | number = NoValuePlaceholder;
    if ((typeof value === 'string' && !!value) || typeof value === 'number') {
        valueOrPlaceholder = value;
    }
    return valueOrPlaceholder;
};

const ClassroomLocationsTab: React.FC = () => {
    return (
        <ArrayField source="classroomLocations">
            <Datagrid
                bulkActionButtons={false}
                sx={{
                    '& .column-title': { backgroundColor: 'red' }
                }}>
                <FunctionField
                    source="name"
                    label="Назва місця"
                    render={(row: ClassroomLocation) => (
                        <Box sx={{ minWidth: '200px' }}>{getValueOrPlaceholder(row.name)}</Box>
                    )}
                />
                ;
                <FunctionField
                    source="building"
                    label="Корпус"
                    textAlign="right"
                    render={(row: ClassroomLocation) => getValueOrPlaceholder(row.building)}
                />
                ;
                <FunctionField
                    source="floor"
                    label="Поверх"
                    textAlign="right"
                    render={(row: ClassroomLocation) => getValueOrPlaceholder(row.floor)}
                />
                ;
                <FunctionField
                    source="block"
                    label="Блок"
                    textAlign="right"
                    render={(row: ClassroomLocation) => getValueOrPlaceholder(row.block)}
                />
                ;
                <FunctionField
                    source="roomNumber"
                    label="№ кабінету"
                    textAlign="right"
                    render={(row: ClassroomLocation) => getValueOrPlaceholder(row.roomNumber)}
                />
                ;
                <FunctionField
                    source="maxSeatingCapacity"
                    label="Макс. кількість людей"
                    textAlign="right"
                    render={(row: ClassroomLocation) => getValueOrPlaceholder(row.maxSeatingCapacity)}
                />
                ;
                <FunctionField
                    label="Призначене для"
                    render={(row: ClassroomLocation) => (
                        // minWidth: '215px' is used to fit in one line all 3 grades
                        <Box sx={{ minWidth: '215px' }}>
                            {getValueOrPlaceholder(getGradesString(row.targetGradeRange as GradeKey[]))}
                        </Box>
                    )}
                />
                ;
            </Datagrid>
        </ArrayField>
    );
};

export default ClassroomLocationsTab;
